/**
 * actions types
 * @type {String}
 */
export const SET_PARAMS = 'SET_PARAMS';

/**
 * initial state
 * @type {Object}
 */
const initialState = {
  params: {},
};

/**
 * reducer
 * @param  {Object} state
 * @param  {Object} action
 * @return {Object}
 */
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_PARAMS:
      return {
        ...state,
        params: action.data,
      };

    default:
      return state;
  }
}

/**
 * set paraams
 * @param  {Object} data
 * @return {Object}
 */
export function setParams(data) {
  return { type: SET_PARAMS, data };
}
